<script>
    import {getNextInputId} from '../../helper/UIHelper';  
    export let model;
    export let label;
    let className = "";
    export {className as class};

    let uid = getNextInputId();
</script>

<div class="{className}">
      {#if label}
      <label class="block text-gray-700 text-sm font-bold mb-2" for="{uid}">
        {label}
      </label>
      {/if}
      <textarea bind:value={model} 
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
            id="{uid}" 
            type="text" 
            placeholder="{label}" />
</div>